import { IcatuCapPaymentMethod } from '../../constants/icatuCap';
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import { IcatuCapProposalSnapshot } from '../../models/IcatuCap/Purchase';
import api, { rawClient } from '../api';

const upsertProposal = (
    id: string,
    proposal: IcatuCapProposalSnapshot
): Promise<IcatuCapProposalSnapshot> =>
    api.request<IcatuCapProposalSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/cap/${id}/proposal`,
        data: decamelizeKeys(proposal),
    });

const submitProposal = (
    id: string,
    paymentMethod: IcatuCapPaymentMethod,
    installmentNumber: number
): Promise<IcatuCapProposalSnapshot> =>
    api.request<IcatuCapProposalSnapshot>({
        method: 'PATCH',
        url: `${getBackVersion()}/agent/cap/${id}/proposal`,
        data: decamelizeKeys({ paymentMethod, installmentNumber }),
    });

const downloadProposal = (id: string): Promise<void> =>
    rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/agent/cap/${id}/proposal/download`,
    });

export { submitProposal, upsertProposal, downloadProposal };
